<script>
import MultiSelect from './MultiSelect.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: MultiSelect, // End of Component > extends
    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    }, // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        /**
         * format the ISD Codes list as required
         *
         * @return {void}
         */
        formatOptions() {
            return this.options.map((option) => {
                return {
                    isdCode: option.isdCode,
                    isdCodeTitle: `${option.isdCode} (${option.title})`,
                    _id: option._id,
                }
            })
        }, // End of formatOptions() method
        model: {
            /**
             * Getter to get value for computed property
             * using props from parent componennt
             *
             * @return {mix}
             */
            get: function () {
                return this.value
            }, // End of get() method
            /**
             * Setter to set value for computed property
             * notifying the parent component
             *
             * @return {void}
             */
            set: function (newValue) {
                this.value = newValue
                this.$store.commit('updateField', {
                    key: this.field.key,
                    value: newValue.isdCode,
                })
            }, // End of set() method
        },
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        model(value) {
            //console.log(value)
            if (value) {
                let selectedItem = this.options.find(
                    (item) => item._id === value._id
                )

                this.$store.commit('updateField', {
                    key: 'contactInfo.isdCountryCodeId',
                    value: selectedItem._id,
                })
            }
        },
    }, // End of Component > watch
}
</script>
